<template>
	<div>
		<modalconfirm ref="modalSave" @action="saveSetting"/>
		<div class="text-h5">Setting Harga Progresif Belanja Stockist</div>
		<v-col cols="12">
            <v-card class="mt-3" outlined>
                <v-col cols="12">
                    <!-- <v-alert dense text type="error" elevation="0" v-if="responseError.price">
                        <div class="text-body-2">{{responseError.price}}</div>
                    </v-alert> -->
                    <v-simple-table class="white-row" no-data-text="Belum ada data tersedia">
                        <template v-slot:default>
                            <thead class="v-data-table-header">
                                <tr>
                                    <th width="5%" class="text-left">Aksi</th>
                                    <th width="40%" class="text-left">BV</th>
                                    <th width="55%" class="text-left">Potongan Harga (Rp/BV)</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(progressive, index) in progressivePrice" :key="index">
                                    <td>
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn class="" fab dark x-small depressed color="pink" v-bind="attrs" v-on="on" @click.stop="deleteProgressive(index)">
                                                    <v-icon dark>mdi-delete</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Hapus</span>
                                        </v-tooltip>
                                    </td>
                                    <td>
                                        <v-currency-field v-model="progressive.bv" :rules="[inputrules.required, inputrules.notnull]" class="py-2 details-mb-0" outlined dense hide-details="auto" background-color="white"></v-currency-field>
                                    </td>
                                    <td>
                                        <v-currency-field v-model="progressive.rebate" :rules="[inputrules.required, inputrules.notnull]" class="py-2 details-mb-0" outlined dense hide-details="auto" background-color="white"></v-currency-field>
                                    </td>
                                </tr>
                            </tbody>
                        </template>
                    </v-simple-table>
                </v-col>
                <v-col cols="12" class="pt-0">
                    <v-btn light depressed color="primary" @click="addData">
                        <v-icon>mdi-plus-circle</v-icon>
                        <div class="pl-2 text-capitalize">Tambah Data</div>
                    </v-btn>
                </v-col>
                <v-card-actions class="px-4 pb-4">
                    <v-spacer></v-spacer>
                    <v-btn color="primary darken-1" :disabled="!progressivePrice" depressed class="text-capitalize" @click="sync">Simpan</v-btn>
                </v-card-actions>
            </v-card>
        </v-col>
	</div>
</template>

<script>

import {mapActions, mapMutations} from 'vuex'

export default {
	inject: ['theme'],
	components: {
	},
	data() {
		return {
			progressivePrice: [],
		}
	},
	props: {
	},
	computed: {
	},
	methods: {
		...mapActions('purchaseOrderStockist', ['getProgressivePrice', 'saveProgressivePrice']),
		...mapMutations(['setOverlay']),

		sync() {
			let msg = `Yakin ingin menyimpan data?`
			this.$refs.modalSave.showConfirm()
			this.$refs.modalSave.setMessage(msg)
		},
		async saveSetting() {
			await this.setOverlay(true)
			await this.$refs.modalSave.hideConfirm()
			let params = await {
				progressive_price: this.progressivePrice
			}

			await this.saveProgressivePrice(params).then(() => {
				//this.resetForm()
			})
			await this.setOverlay(false)
		},
		resetForm() {
			this.getData()
		},
		async getData() {
			await this.getProgressivePrice().then((response) => {
				//console.log(response)
                this.progressivePrice = response
			}).catch(() => {
				//console.log(response)
			})
		},
        addData() {
			//this.responseError.product = ''
            //console.log(this.progressivePrice)

			this.progressivePrice.push({
                bv: 0,
                rebate: 0
			})

            //console.log(this.progressivePrice)
		},
        deleteProgressive(index){
			this.progressivePrice.splice(index, 1)
		},
	},
	created() {
		this.$store.dispatch('setPageTitle', `Setting Harga Progresif Belanja Stockist`)
		this.getData()
	},
	beforeDestroy() {
	},
	watch: {
		
	}
}
</script>